import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import {am4Settings} from "@/mixins/am4charts/am4Settings";

const COLOR_ALARM = am4core.color('#8f000f')
const COLOR_CAUTION = am4core.color('#bfcf29')

export const am4AxisMixin = {
    data() {
        return {
            am4AxisMixinData: {
                xAxisBottom: null,
                xAxisTop: null,
                yAxisLeft: null,
                yAxisRight: null,
            },
        }
    },
    mounted() {

    },
    methods: {
        // Date axis which is defaulted to the x axis
        am4CreateDateAxis(chart, whichAxis = 'x') {
            if (this._am4ChartInvalid(chart)) {
                console.error(`Unable to add Date Axis on (${whichAxis}).  Chart not valid`)
                return null;
            }
            let axis = null
            if (whichAxis === 'x') {
                axis = chart.xAxes.push(new am4charts.DateAxis())
                if (_.isNil(this.am4AxisMixinData.xAxisBottom)) {
                    this.am4AxisMixinData.xAxisBottom = axis
                }
                else {
                    this.am4AxisMixinData.xAxisTop = axis
                    axis.renderer.opposite = true
                }
            }
            else {
                axis = chart.yAxes.push(new am4charts.DateAxis())
                if (_.isNil(this.am4AxisMixinData.yAxisLeft)) {
                    this.am4AxisMixinData.yAxisLeft = axis
                }
                else {
                    this.am4AxisMixinData.yAxisRight = axis
                    axis.renderer.opposite = true
                }
            }

            return axis
        },

        // Value Axis which is defaulted to y axis
        am4CreateValueAxis(chart, whichAxis = 'y') {
            if (this._am4ChartInvalid(chart)) {
                console.error(`Unable to add value Axis on (${whichAxis}).  Chart not valid`)
                return null;
            }
            let axis = null
            if (whichAxis === 'x') {
                axis = chart.xAxes.push(new am4charts.ValueAxis())
                if (_.isNil(this.am4AxisMixinData.xAxisBottom)) {
                    this.am4AxisMixinData.xAxisBottom = axis
                }
                else {
                    this.am4AxisMixinData.xAxisTop = axis
                    axis.renderer.opposite = true
                }
            }
            else {
                axis = chart.yAxes.push(new am4charts.ValueAxis())
                if (_.isNil(this.am4AxisMixinData.yAxisLeft)) {
                    this.am4AxisMixinData.yAxisLeft = axis
                }
                else {
                    this.am4AxisMixinData.yAxisRight = axis
                    axis.renderer.opposite = true
                }
            }

            return axis
        },

        // Setup Date Axis
        am4SetupDateAxis(dateAxis, formatter = null) {
            if (!_.isNil(formatter)) {
                dateAxis.dateFormatter = this.formatter
            }
            dateAxis.renderer.baseGrid.disabled = true
            dateAxis.renderer.labels.template.disabled = false
            dateAxis.renderer.grid.template.location = 0
            dateAxis.renderer.minGridDistance = 60
            dateAxis.gridIntervals.setAll([
                { timeUnit: 'second', count: 1, },
                { timeUnit: 'minute', count: 1, },
                { timeUnit: 'minute', count: 5, },
                { timeUnit: 'minute', count: 15, },
                { timeUnit: 'minute', count: 60, },
                { timeUnit: 'hour', count: 4, },
                { timeUnit: 'day', count: 1, },
                { timeUnit: 'day', count: 7, },
                { timeUnit: 'day', count: 14, },
                { timeUnit: 'month', count: 1, },
                { timeUnit: 'month', count: 3, },
                { timeUnit: 'month', count: 6, },
                { timeUnit: 'year', count: 1, },
            ])
        },

        // Setup Value Axis
        am4SetupValueAxis(valueAxis, min, max) {
            // Give a buffer on either side of the minimum or maximum of the chart based on at least a percentage of the chart's height
            if (_.isNil(valueAxis)) {
                return
            }
            let l = max - min
            valueAxis.min = min - l * am4Settings.Y_AXIS_SPACE_PERCENT
            valueAxis.max = max + l * am4Settings.Y_AXIS_SPACE_PERCENT
            valueAxis.tooltip.disabled = true
            valueAxis.renderer.minWidth = 35
        },

        // Setup Date Axis Tooltip
        am4SetupDateAxisTooltip(dateAxis, series) {
            dateAxis.tooltipDateFormat = 'MM/dd/yyyy HH:mm:ss'
            // Figure out a way to have this not get created or run until data is rendered.
            dateAxis.adapter.add('getTooltipText', (tooltip, target) => {
                try {
                    let data = series.tooltipDataItem

                    if (!data) {
                        return `Default (No Data): ${tooltip}`
                    }
                    let date = null
                    if (data.groupDataItems && data.groupDataItems.length > 0) {
                        date = data.groupDataItems[0].dataContext.date
                    }
                    else {
                        date = data.dates.dateX
                    }
                    if (!date) {
                        return `Default (No Date): ${tooltip}`
                    }
                    return `${date.toLocaleDateString("en-US", {timeZone: this.timezone})}  ${date.toLocaleTimeString("en-US", {timeZone: this.timezone})}`
                }
                catch (e) {
                    return tooltip
                }
            })
        },

        // Setup Date Axis Grouping [INC]
        am4SetupDateAxisGrouping(chart, dateAxis, series) {
            if (this._am4ChartInvalid(chart)) {
                return
            }

            // Se if we can get this to work at all.
            // TODO. Connect this.getIntervals & this.updateGapAndMinBulletDistance

            dateAxis.groupData = true
            dateAxis.groupCount = 750
            let interval = this.getIntervals(dateAxis.groupCount)
            dateAxis.groupIntervals.setAll(interval)

            // this.chartEvents.push(dateAxis.events.on('datarangechanged', target => {
            dateAxis.events.on('datarangechanged', target => {
                if (dateAxis.groupData === false) {
                    return
                }

                let currentInterval = dateAxis.groupIntervals.getIndex(0)
                let interval = this.getIntervals(dateAxis.groupCount, dateAxis.end - dateAxis.start)
                if (interval[0].timeUnit !== currentInterval.timeUnit || interval[0].count !== currentInterval.count) {
                    dateAxis.groupIntervals.setAll(interval)
                    chart.cursor.disabled = true
                    chart.series.forEach((item, key) => {
                        series.dataGrouped = false
                        dateAxis.groupSeriesData(series)
                    })
                    setTimeout(() => {
                        chart.chart.cursor.disabled = false
                        series.dataGrouped = true
                        this.updateGapAndMinBulletDistance(dateAxis)
                    }, 10)
                }
            })
            // )
        },

        // Setup Alarm Guides
        am4SetupAlarmGuides(dateAxis, valueAxis, alarmInfo, axis = am4Settings.AXIS_LEFT) {
            // Alarm Guides
            let alarmValues = {
                highAlarmValue: null,
                highCautionValue: null,
                lowCautionValue: null,
                lowAlarmValue: null,
            }
            Object.keys(alarmInfo.alarm).forEach(key => {
                let item = alarmInfo.alarm[key]
                if (item === null) {
                    return
                }
                let range = valueAxis.axisRanges.create();
                range.value = item;
                range.grid.stroke = COLOR_ALARM
                range.grid.strokeWidth = 2;
                range.grid.strokeOpacity = 1;
                if (axis === am4Settings.AXIS_RIGHT) {
                    range.grid.strokeDasharray = '5,4'
                }

                if(key === 'high_alarm'){
                    alarmValues.highAlarmValue = item;
                } else if (key === 'low_alarm'){
                    alarmValues.lowAlarmValue = item;
                }
            })

            // Caution guides
            Object.keys(alarmInfo.caution).forEach(key => {
                let item = alarmInfo.caution[key]
                if (item === null) {
                    return
                }
                let range = valueAxis.axisRanges.create();
                range.value = item;
                range.grid.stroke = COLOR_CAUTION
                range.grid.strokeWidth = 2;
                range.grid.strokeOpacity = 1;
                if (axis === am4Settings.AXIS_RIGHT) {
                    range.grid.strokeDasharray = '5,4'
                }

                // Only replace if it wasn't set OR it's a lower value
                if(key === 'high_caution'){
                    alarmValues.highCautionValue = item;
                } else if (key === 'low_caution'){
                    alarmValues.lowCautionValue = item;
                }
            })

            return alarmValues
        },

        // Reset date axis min / max
        am4ResetDateAxis(min, max, dateAxis = null) {
            // TODO. Verify that the min & max date are valid dates

            // if (_.isNil(dateAxis)) {
            //     dateAxis.min = min.getTime()
            //     dateAxis.max = max.getTime()
            //     return
            // }

            // The reset all doesn't work atm.
            // this.am4YAxes.forEach((axis, index) => {
            //     if (!(axis instanceof am4charts.DateAxis)) {
            //         return
            //     }
            //
            //     this.am4YAxes[index].min = min.getTime()
            //     this.am4YAxes[index].max = max.getTime()
            // })
            // this.am4XAxes.forEach((axis, index) => {
            //     if (!(axis instanceof am4charts.DateAxis)) {
            //         return
            //     }
            //
            //     this.am4XAxes[index].min = min.getTime()
            //     this.am4XAxes[index].max = max.getTime()
            // })
        },

        // Ensure that the chart exists
        _am4ChartInvalid(chart) {
            return _.isNil(chart)
        },

        // Dispose a part of value from the am4 framework.
        _dispose(element) {
            if (!_.isNil(element)) {
                element.dispose()
                return null
            }
            return element
        },
    },
    unmounted() {
        this._dispose(this.am4AxisMixinData.xAxisBottom)
        this._dispose(this.am4AxisMixinData.xAxisTop)
        this._dispose(this.am4AxisMixinData.yAxisLeft)
        this._dispose(this.am4AxisMixinData.yAxisRight)
    },
}